// @mui
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
//
import useLocales from './useLocales';

import { plPL } from '@mui/x-date-pickers/locales';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ThemeLocalization({ children }: Props) {
  const outerTheme = useTheme();

  const { currentLang } = useLocales();
  // plPL,
  // const theme = createTheme(outerTheme, currentLang.systemValue);
  const theme = createTheme(outerTheme, plPL);

  return <ThemeProvider theme={theme}> {children} </ThemeProvider>;
}
